export const Global = {
    url: 'https://backend.biosecuritytrack.com/api/v1/'
}